import React, { useState } from "react";
import {
  Card,
  Table,
  Form,
  Dropdown,
  Row,
  Col
} from "react-bootstrap";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";


const data = [
  {
    id: "Inv-001",
    name: "Michael Walker",
    role: "CEO",
    img: "/assets/img/users/user-39.jpg",
    company: "BrightWave Innovations",
    type: "Paypal",
    date: "15 Jan 2024",
    amount: "$3000",
  },
  {
    id: "Inv-002",
    name: "Sophie Headrick",
    role: "Manager",
    img: "/assets/img/users/user-40.jpg",
    company: "Stellar Dynamics",
    type: "Paypal",
    date: "25 Jan 2024",
    amount: "$2500",
  },
  {
    id: "Inv-003",
    name: "Cameron Drake",
    role: "Director",
    img: "/assets/img/users/user-41.jpg",
    company: "Quantum Nexus",
    type: "Paypal",
    date: "22 Feb 2024",
    amount: "$2800",
  },
    {
    id: "Inv-001",
    name: "Michael Walker",
    role: "CEO",
    img: "/assets/img/users/user-42.jpg",
    company: "BrightWave Innovations",
    type: "Paypal",
    date: "15 Jan 2024",
    amount: "$3000",
  },
  {
    id: "Inv-002",
    name: "Sophie Headrick",
    role: "Manager",
    img: "/assets/img/users/user-43.jpg",
    company: "Stellar Dynamics",
    type: "Paypal",
    date: "25 Jan 2024",
    amount: "$2500",
  },
  {
    id: "Inv-003",
    name: "Cameron Drake",
    role: "Director",
    img: "/assets/img/users/user-44.jpg",
    company: "Quantum Nexus",
    type: "Paypal",
    date: "22 Feb 2024",
    amount: "$2800",
  },
];

export default function PaymentsTable() {
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [sort, setSort] = useState("Last 7 Days");
  const [dateRange, setDateRange] = useState([null, null]);

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Card className="payment-card">
      {/* HEADER */}
      <Card.Header className="d-flex flex-wrap justify-content-between align-items-center gap-3">
        <h5 className="mb-0">Payment List</h5>

        <div className="d-flex flex-wrap gap-3 align-items-center">

          {/* DATE PICKER */}
          <div className="date-box">
            <FaCalendarAlt className="text-dark" />
            <DatePicker
              selectsRange
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onChange={(update) => setDateRange(update)}
              placeholderText="dd/mm/yyyy - dd/mm/yyyy"
              className="form-control"
            />
          </div>

          {/* SORT DROPDOWN */}
          <Dropdown>
            <Dropdown.Toggle className="date-box text-dark">
              Sort By : {sort}
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" className="p-2">
              {[
                "Recently Added",
                "Ascending",
                "Descending",
                "Last Month",
                "Last 7 Days",
              ].map((item) => (
                <Dropdown.Item
                  key={item}
                  onClick={() => setSort(item)}
                  className={sort === item ? "active-item" : ""}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Card.Header>

      {/* FILTER ROW */}
      <div className="p-3 border-bottom">
        <Row className="align-items-center g-2">
          <Col xs={12} md={6} className="d-flex align-items-center gap-2">
            <span>Row Per Page</span>
            <Form.Select
              value={rows}
              onChange={(e) => setRows(e.target.value)}
              style={{ width: "80px" }}
            >
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </Form.Select>
            <span>Entries</span>
          </Col>

          <Col xs={12} md={6} className="text-md-end">
            <Form.Control
              placeholder="Search"
              className="search-box"
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <Table style={{backgroundColor:"#ffff"}} className="mb-0">
          <thead  style={{backgroundColor:"#ffff"}} className="table-light">
            <tr  >
              <th>Invoice ID</th>
              <th>Client Name</th>
              <th>Company Name</th>
              <th>Payment Type</th>
              <th>Paid Date</th>
              <th>Paid Amount</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.slice(0, rows).map((item, i) => (
              <tr key={i}>
                <td className="text-primary fw-medium">{<Link to="/invoice-details" className="text-decoration-none text-dark" >
                {item.id}</Link>}</td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={item.img}
                      className="avatar"
                      alt=""
                    />
                    <div>
                      <div className="fw-medium">{item.name}</div>
                      <small className="text-muted">{item.role}</small>
                    </div>
                  </div>
                </td>

                <td>{item.company}</td>
                <td>{item.type}</td>
                <td>{item.date}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <style>
          {
               `
               .payment-card {
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

/* DATE INPUT */
.date-box {
  position: relative;
}

.calendar-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  color: #6b7280;
}

// .date-box input {
//   padding-left: 35px;
// //   min-width: 150px;
// }

/* SEARCH */
.search-box {
  max-width: 250px;
  margin-left: auto;
}

/* AVATAR */
.avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
}

/* DROPDOWN */
.btn-white {
  background: #fff;
  border: 1px solid #ddd;
}

.active-item {
  background-color: #ff6a00 !important;
  color: #fff !important;
  border-radius: 5px;
}

/* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}
/* MOBILE */
@media (max-width: 768px) {
  .search-box {
    max-width: 100%;
    margin-top: 10px;
  }

  .date-box input {
    min-width: 100%;
  }
}`
          }
      </style>
    </Card>
  );
}